import React from "react";

/**
 * Sentry Cloud IT — official brand logo.
 * Renders the wide "SENTRY · Speed · Strength · Security" wordmark PNG.
 * The PNG already contains the wordmark, so `showText` is ignored (kept for
 * backwards compat with existing call sites).
 */
export default function Logo({ size = 32, showText: _showText = true, className = "" }) {
  // Sentry Cloud IT full brand logo (SENTRY wordmark + shield + tagline).
  // Natural 4:3 aspect; width auto-scales from height.
  const height = size;
  return (
    <img
      src="/brand/sentry-square.png"
      alt="Sentry Cloud IT"
      height={height}
      style={{ height, width: "auto" }}
      className={`block select-none ${className}`}
      draggable={false}
      data-testid="sentry-logo"
    />
  );
}
